export default __webpack_public_path__ + "static/media/logo_linkedin_white.a9c25b28.svg";